import { Environment } from "@models/environment.interface";
import { path } from './url-path';

const env = 'uat';

export const environment: Environment = {
    env,
    production: false,
    url: {
        api: {
            root: `https://${env}.reports.csmedley.net/api`,
            path: path.api
        },
        client: {
            root: `https://${env}.reports.csmedley.net`,
            path: path.client
        }
    }
};
